import dynamic from "next/dynamic";

export const DynamicContent085 = dynamic(() => import("./Content085"), {
  suspense: true,
});
